import * as types from 'src/store/types/index';
import { getUserShopCount } from 'src/service/shop';
import { sendLog } from 'src/logger/customLogger';
import { ShopType } from 'src/const/state/shop';

const getShopDefaultState = () => ({
  selectedSpuId: '', // 当前选择的 spu id
  shopInfo: {}, // 选择的 shop 数据
  selectedSpuList: [], // 多选商品的商品长度
});

export default {
  namespaced: true,
  state: {
    ...getShopDefaultState(),
    hasMagellanShop: false,
  },
  getters: {
    shopId({ shopInfo }) {
      return shopInfo?.id || '';
    },
    shopType({ shopInfo }) {
      return shopInfo?.type;
    },
    shopCountry({ shopInfo }) {
      return shopInfo?.country || [];
    },
  },
  mutations: {
    [types.RESET_SHOP_STATE](state) {
      Object.assign(state, getShopDefaultState());
    },
    [types.SET_SHOP_INFO](state, shopInfo = {}) {
      state.shopInfo = shopInfo;
    },
    [types.SET_SELECTED_SPU_ID](state, spuId = '') {
      state.selectedSpuId = spuId;
    },
    [types.SET_SELECTED_SPU_LIST](state, spuList = []) {
      state.selectedSpuList = spuList;
    },
    [types.SET_HAS_MAGELLAN_SHOP](state, hasMagellanShop = false) {
      state.hasMagellanShop = hasMagellanShop;
    },
  },
  actions: {
    // 获取当前用户是否有1P shop
    async getUserHasMagellanShop({ state, commit }) {
      if (state.hasMagellanShop) {
        return;
      }
      try {
        const shopCount = await getUserShopCount(ShopType.ecommShop);
        commit(types.SET_HAS_MAGELLAN_SHOP, shopCount > 0);
      } catch (e) {
        sendLog('custom', {
          event_name: 'getUserHasMagellanShop Failed',
        });
      }
    },
  },
};
